export default class MolecularFormulaManipulator {
  static subNumbers(mf){
    if (!mf)
      return '';
    let result = '', subOpened = false;
    for (let i = 0; i < mf.length; i++) {
      const c = mf.charAt(i);
      if (parseInt(c) >= 0){
        if (!subOpened){
          subOpened = true;
          result += '<sub>'
        }
      } else if (subOpened){
        subOpened = false;
        result += '</sub>'
      }
      result += c;
    }
    return result
  }
}